export default from './cover';



// WEBPACK FOOTER //
// ./app/components/cover/index.js